export default class CompletedUpload {
  constructor({
    id,
    jobId,
    filename,
    fileType,
    fileSize,
    url,
    targetOrg,
    uploadOrg,
    uploadUser,
    jobTree,
    uploadedBy,
    uploadCompletedTime,
    uploadCompleted,
    createdTime,
    hidden,
    updatedAt,
    standardKey,
    storageRegion,
    sewerData,
    downloadUrl,
    playUrl,
  }) {
    this.id = id;
    this.jobId = jobId;
    this.filename = filename;
    this.fileType = fileType;
    this.fileSize = fileSize;
    this.url = url;
    this.targetOrg = targetOrg;
    this.uploadOrg = uploadOrg;
    this.uploadUser = uploadUser;
    this.jobTree = jobTree;
    this.uploadedBy = uploadedBy;
    this.uploadCompletedTime = new Date(uploadCompletedTime);
    this.uploadCompleted = uploadCompleted;
    this.createdTime = new Date(createdTime);
    this.hidden = hidden;
    this.updatedAt = new Date(updatedAt);
    this.standardKey = standardKey;
    this.storageRegion = storageRegion;
    this.sewerData = sewerData;
    this.downloadUrl = downloadUrl;
    this.playUrl = playUrl;
  }

  static fromServerModel(data) {
    return new CompletedUpload(data);
  }
}
